module.exports = __webpack_public_path__ + "img/logo.613fe5ea.jpg";